export default function authHeader() {
    let user = JSON.parse(localStorage.getItem('user'));
  
    if (user ) { //&& user.token
      return { Authorization: user }; //se guarda el token directamente en 'user'
    } else {
      return {};
    }
  }